module.exports = new __parcel__URL__("AetherBenefitsModalHero.f5157d0b.svg").toString();